
export const required = {
  required: true,
  message: "Este campo es obligatorio",
};

export const espacioBlanco = {
  message: "Este no puede tener espacios en blanco",
  validator: (_, value) => {
    const regex =
      /[a-zA-Z\t\h]+|(^$)/
    if (regex.test(value)) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  },
}

export const validarEmail = {
  message: "Formato de email invalido",
  validator: (_, value) => {
    const regex =
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

    if (regex.test(value)) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  },
};

export const campoNumerico = {
  message: "Este campo solo puede contener números",
  validator: (_, value) => {
    const regex =
      /^[0-9]*$/

    if (regex.test(value)) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  },
};


export const rango = (min, max) => {
  return () => ({
    validator(rule, value) {
      const number = parseFloat(value);
      if (number >= min && number <= max) {
        return Promise.resolve();
      }
      return Promise.reject(`El valor debe estar entre ${min} y ${max}`);
    },
  });
};

export const maximoCaracteres = (max) => {
  return () => ({
    validator(rule, value) {
      if (!value) {
        return Promise.resolve();
      }
      if (value) {
        const strValue = value.toString();
        if (strValue.length <= max) {
          return Promise.resolve();
        }
      }
      return Promise.reject(`El valor debe tener como máximo ${max} caracteres`);
    },
  });
};


//   export const valorPositivo = {
//     message: "El campo debe ser mayor o igual a 0",
//     validator: (_, value) => {
//       if (value < 0 ) {
//         return Promise.reject();
//       } else {
//         return Promise.resolve();
//       }
//     }
//   };
